var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M5.73 13.93a.48.48 0 1 0 0-.96.48.48 0 0 0 0 .96Zm1.92 4.79a.48.48 0 1 0 0-.96.48.48 0 0 0 0 .96Zm-.96-9.59a.48.48 0 1 0 0-.96.48.48 0 0 0 0 .96Zm3.83-2.87a.48.48 0 1 0 0-.96.48.48 0 0 0 0 .96Zm4.8.96a.48.48 0 1 0 0-.96.48.48 0 0 0 0 .96Zm2.88 3.83a.48.48 0 1 0 0-.96.48.48 0 0 0 0 .96Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M22.51 11.86a4.87 4.87 0 0 1-4.86 4.95h-1.47a4.28 4.28 0 0 0-3.57 1.91l-1.15 1.72a4.74 4.74 0 0 1-4 2.12 4.61 4.61 0 0 1-3.87-2 13.07 13.07 0 0 1-2.18-7.26V12a10.55 10.55 0 0 1 21.1-.15v.01Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.9fe6ad4dc2aeca8d6afba26216c0efa4.svg";
export { ForwardRef as ReactComponent };